import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Composant Portal pour rendre du contenu en dehors de la hiérarchie DOM normale
 * Utile pour les modals, dropdowns, tooltips qui doivent s'afficher au-dessus de tout
 */
const Portal = ({ children, id = 'portal-root' }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    
    // Créer le conteneur portal s'il n'existe pas
    let portalRoot = document.getElementById(id);
    if (!portalRoot) {
      portalRoot = document.createElement('div');
      portalRoot.id = id;
      portalRoot.style.position = 'fixed';
      portalRoot.style.zIndex = '2147483647'; // z-index maximum
      portalRoot.style.top = '0';
      portalRoot.style.left = '0';
      portalRoot.style.width = '100%';
      portalRoot.style.height = '100%';
      portalRoot.style.pointerEvents = 'none'; // Permet les clics à travers le conteneur
      document.body.appendChild(portalRoot);
    }

    return () => {
      setMounted(false);
    };
  }, [id]);

  if (!mounted) return null;

  const portalRoot = document.getElementById(id);
  if (!portalRoot) return null;

  return createPortal(children, portalRoot);
};

export default Portal;
